document.addEventListener('DOMContentLoaded', function () {
  var navItems = document.querySelectorAll('.navigation-wrapper .navigation-item.has-sub-menu');

  function closeSiblings(item) {
    var parent = item.parentElement;
    if (!parent) return;
    var siblings = parent.querySelectorAll(':scope > .navigation-item.has-sub-menu');
    siblings.forEach(function (sibling) {
      if (sibling !== item) {
        sibling.classList.remove('is-open');
      }
    });
  }

  navItems.forEach(function (item) {
    var link = item.querySelector(':scope > a');
    if (!link) return;

    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var isOpen = item.classList.contains('is-open');
      closeSiblings(item);
      item.classList.toggle('is-open', !isOpen);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.navigation-wrapper')) {
      document.querySelectorAll('.navigation-wrapper .is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.navigation-wrapper .is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    }
  });
});